module.exports = __webpack_public_path__ + "static/media/icon_back_mobile.616a99e9.svg";